var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { MAX_DEGREE } from './coefficients';
export function _getDimension(
// biome-ignore lint/suspicious/noExplicitAny: p5 typing
context, isP3D) {
    return context.constructor.name === 'WebGLRenderingContext' || isP3D ? 3 : 2;
}
export function _getCanvasUtils(b) {
    if (b.useP5) {
        b.beginPath = b.canvas.beginShape;
        b.moveTo = b.canvas.vertex;
        b.lineTo = b.canvas.vertex;
        b.closePath = b.canvas.endShape;
    }
    else {
        if (b.ctx instanceof WebGLRenderingContext) {
            b.beginPath = function () { };
            b.moveTo = function (x, y, z) {
                if (z === void 0) { z = 0; }
                return b.ctx.vertexAttrib3f(0, x, y, z);
            };
            b.lineTo = function (x, y, z) {
                if (z === void 0) { z = 0; }
                return b.ctx.vertexAttrib3f(0, x, y, z);
            };
            b.closePath = function () { };
        }
        else {
            b.beginPath = b.ctx.beginPath.bind(b.ctx);
            b.moveTo = b.ctx.moveTo.bind(b.ctx);
            b.lineTo = b.ctx.lineTo.bind(b.ctx);
            b.closePath = b.ctx.closePath.bind(b.ctx);
        }
    }
}
export function _dist() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var len = args.length;
    if (len === 4) {
        var dx = args[0] - args[2];
        var dy = args[1] - args[3];
        return Math.sqrt(dx * dx + dy * dy);
    }
    if (len === 6) {
        var dx = args[0] - args[3];
        var dy = args[1] - args[4];
        var dz = args[2] - args[5];
        return Math.sqrt(dx * dx + dy * dy + dz * dz);
    }
    return 0;
}
export function _setStyles(b) {
    if (b.canvas._doFill)
        b.ctx.fill();
    if (b.canvas._doStroke)
        b.ctx.stroke();
}
var warnedSmoothness = false;
export function _validateSmoothness(smoothness) {
    if (smoothness < 1 || smoothness > 5 || !Number.isInteger(smoothness)) {
        if (!warnedSmoothness) {
            warnedSmoothness = true;
            window.console.warn('[p5.bezier] Smoothness should be an integer between 1 and 5');
        }
        return Math.round(Math.max(1, Math.min(5, smoothness)));
    }
    return smoothness;
}
/* -------------------------------------------------------------------------- */
var SeedRandom = /** @class */ (function () {
    function SeedRandom(seed) {
        this.m = Math.pow(2, 31) - 1;
        this.a = 1103515245;
        this.c = 12345;
        this.state = seed;
    }
    SeedRandom.prototype.r = function () {
        this.state = (this.a * this.state + this.c) % this.m;
        return this.state / this.m;
    };
    SeedRandom.prototype.next = function (min, max) {
        return Math.floor(this.r() * (max - min + 1)) + min;
    };
    return SeedRandom;
}());
var seed = 1234;
export function _concentrate(pointList, close) {
    if (close === void 0) { close = false; }
    var save = close ? 3 : 0;
    var limit = MAX_DEGREE - save;
    if (pointList.length <= limit)
        return _copy(pointList);
    var excessPoints = pointList.length - limit;
    var rng = new SeedRandom(seed);
    var rmIndex = new Set();
    __spreadArray([], new Array(excessPoints), true).map(function (_, ind) {
        var r = rng.next(5 + ind, limit - 5 + ind);
        while (rmIndex.has(r)) {
            r = rng.next(5 + ind, limit - 5 + ind);
        }
        rmIndex.add(r);
    });
    return _copy(pointList.filter(function (_, index) { return !rmIndex.has(index); }));
}
function _copy(arr) {
    return arr.map(function (v) { return v.slice(); });
}
export function _getCloseCurvePoints(pointList) {
    var len = pointList.length;
    if (len === 0)
        return [];
    var first = pointList[0];
    var last = pointList[len - 1];
    if (len === 1)
        return _copy([first]);
    var second = pointList[1];
    var secondLast = pointList[len - 2];
    return _copy([
        [2 * last[0] - secondLast[0], 2 * last[1] - secondLast[1]],
        [2 * first[0] - second[0], 2 * first[1] - second[1]],
        first,
    ]);
}
export function _interpolateVertex(v1, v2, t) {
    var len1 = v1.length;
    var len2 = v2.length;
    if (len1 === 2 && len2 === 2) {
        return [v1[0] + (v2[0] - v1[0]) * t, v1[1] + (v2[1] - v1[1]) * t];
    }
    if (len1 === 3 && len2 === 3) {
        return [
            v1[0] + (v2[0] - v1[0]) * t,
            v1[1] + (v2[1] - v1[1]) * t,
            v1[2] + (v2[2] - v1[2]) * t,
        ];
    }
    return v2;
}
